export const educationData = [
    {
        id: 3,
        institution: 'Bharati Vidyapeeth University',
        course: 'Bachelor of Technology',
        startYear: '2015',
        endYear: '2019'
    },
 
  
]